import qs from 'qs';

export const routes = {
  calendar: ({ action, eventId }: { action: 'edit'; eventId: string }) =>
    `/calendar?${qs.stringify({ action, eventId })}`,
  index: '/',
  tokenLogin: '/token/login',
  user: {
    detail: (userId: string) => `/users/${userId}`,
  },
};
